module.exports = __webpack_public_path__ + "img/组 10@2x.0bdedfc0.png";